import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class extends Controller {
  static targets = ['profileImage', 'fullName'];

  profileImageTargetConnected(img) {
    img.src = CurrentUser.getProfileImage(img.width, img.height);
  }

  fullNameTargetConnected(node) {
    node.innerHTML = CurrentUser.fullName();
  }
}
